import config from "./config";
import axios from "axios";

export const industryTree = params => {
  return axios.get(config.industryTree, params);
};
export const dictAll = params => {
  return axios.get(config.dictAll, params);
};
export const getUserNameList = params => {
  return axios.get(config.getUserNameList, params);
};
export const invitationDetails = params => {
  return axios.get(
    config.invitationDetails +
      `?jobId=${params.jobId}&chatId=${params.chatId}&viStep=${params.viStep}&uid=${params.uid}`,
    params
  );
};
export const resumeDetail = params => {
  return axios.get(config.resumeDetail, params);
};
export const inVipIdFindRights = params => {
  return axios.get(config.inVipIdFindRights, params);
};
export const resourcelog = params => {
  return axios.get(config.resourcelog, params);
};
export const zhy = params => {
  return axios.get(config.zhy, { params, params });
};
export const getIsCall = params => {
  return axios.get(config.getIsCall, { params: params });
};
export const findVipInfo = params => {
  return axios.get(config.findVipInfo, params);
};
export const positionDetail = params => {
  return axios.get(config.positionDetail, params);
};
export const hotKeywords = params => {
  return axios.get(config.hotKeywords, params);
};
export const deleteAddress = params => {
  return axios.get(config.deleteAddress, params);
};
export const infoDetail = params => {
  return axios.get(config.infoDetail, params);
};
export const resumeJobList = params => {
  return axios.get(config.resumeJobList, params);
};
export const walletP = params => {
  return axios.get(config.walletP, params);
};
export const collectJobYes = params => {
  return axios.get(config.collectJobYes, params);
};
export const walletList = params => {
  return axios.get(config.walletList, params);
};
export const companyDetail = params => {
  return axios.get(config.companyDetail, params);
};
export const pcResult = params => {
  return axios.get(config.pcResult, params);
};
export const markEr = params => {
  return axios.get(config.markEr, params);
};
export const markHr = params => {
  return axios.get(config.markHr, params);
};
export const pcQrcode = params => {
  return axios.get(config.pcQrcode, params);
};
export const setdefault = params => {
  return axios.get(config.setdefault, params);
};
export const collectJobNo = params => {
  return axios.get(config.collectJobNo, params);
};
export const service = params => {
  return axios.get(config.service, params);
};
export const collectMeList = params => {
  return axios.get(config.collectMeList, params);
};
export const unmarkBlack = params => {
  return axios.get(config.unmarkBlack, params);
};
export const blacklist = params => {
  return axios.get(config.blacklist, params);
};
export const markkBlack = params => {
  return axios.get(config.markkBlack, params);
};
export const collectListPrise = params => {
  return axios.get(config.collectListPrise, params);
};
export const collectMeListPrise = params => {
  return axios.get(config.collectMeListPrise, params);
};
export const czPrise = params => {
  return axios.get(config.czPrise, params);
};
export const lsPrise = params => {
  return axios.get(config.lsPrise, params);
};
export const hasChatList = params => {
  return axios.get(config.hasChatList, params);
};
export const walletPrise = params => {
  return axios.get(config.walletPrise, params);
};
export const noLoginInfo = params => {
  return axios.get(config.noLoginInfo, params);
};
export const collectJobList = params => {
  return axios.get(config.collectJobList, params);
};
export const companyblacklist = params => {
  return axios.get(config.companyblacklist, params);
};
export const removeBlack = params => {
  return axios.get(config.removeBlack, params);
};
export const hasSendResume = params => {
  return axios.get(config.hasSendResume, params);
};
export const jobNameList = params => {
  return axios.get(config.jobNameList, params);
};
export const resumeSrearch = params => {
  return axios.get(config.resumeSrearch, params);
};
export const jobUrgent = params => {
  return axios.put(config.jobUrgent, params);
};
export const addressList = params => {
  return axios.get(config.addressList, params);
};
export const indexPages = params => {
  return axios.get(config.indexPages, params);
};
export const erHomeInfo = params => {
  return axios.get(config.erHomeInfo, params);
};
export const commonUserInfo = params => {
  return axios.get(config.commonUserInfo, params);
};
export const getListForHr = params => {
  return axios.post(config.getListForHr, params);
};
export const sendResume = data => {
  return axios.post(config.sendResume, data);
};
export const phrasesAdd = data => {
  return axios.post(config.phrasesAdd, data);
};
export const updateSort = data => {
  return axios.post(config.updateSort, data);
};
export const addressAdd = data => {
  return axios.post(config.addressAdd, data);
};
export const phrasesDel = data => {
  return axios.post(config.phrasesDel, data);
};
export const interViewfeedback = data => {
  return axios.post(config.interViewfeedback, data);
};
export const mainCompanyResource = data => {
  return axios.post(config.mainCompanyResource, data);
};
export const askForResume = data => {
  return axios.post(config.askForResume, data);
};
export const companyuncollect = data => {
  return axios.post(config.companyuncollect, data);
};
export const companyCollect = data => {
  return axios.post(config.companyCollect, data);
};
export const saveHonerPic = data => {
  return axios.post(config.saveHonerPic, data);
};
export const phrasesEdit = data => {
  return axios.post(config.phrasesEdit, data);
};
export const saveAlbum = data => {
  return axios.post(config.saveAlbum, data);
};
export const batchUploadPicture = data => {
  return axios.post(config.batchUploadPicture, data);
};
export const uploadLogo = data => {
  return axios.post(config.uploadLogo, data);
};

export const swapMobile = data => {
  return axios.post(config.swapMobile, data);
};
export const swapWechat = data => {
  return axios.post(config.swapWechat, data);
};
export const uploadAvatar = data => {
  return axios.post(config.uploadAvatar, data);
};
export const companyUp = data => {
  return axios.post(config.companyUp, data);
};
export const companyView = data => {
  return axios.post(config.companyView, data);
};
export const chatSay = data => {
  return axios.post(config.chatSay, data);
};
export const chatJoin = data => {
  return axios.post(config.chatJoin, data);
};
export const messageAdds = data => {
  return axios.post(config.messageAdds, data);
};
export const serviceDownload = data => {
  return axios.post(config.serviceDownload, data);
};
export const authority = data => {
  return axios.post(config.authority, data);
};
export const roleHrTeamInfo = data => {
  return axios.post(config.roleHrTeamInfo, data);
};
export const roleAdd = data => {
  return axios.post(config.roleAdd, data);
};
export const hrComeurl = data => {
  return axios.post(config.hrComeurl, data);
};
export const companyHrTeamE = data => {
  return axios.post(config.companyHrTeamE, data);
};
export const companyHrTeamEdit = data => {
  return axios.post(config.companyHrTeamEdit, data);
};
export const queryHrTeamPayRelated = data => {
  return axios.post(config.queryHrTeamPayRelated, data);
};
export const signUser = data => {
  return axios.post(config.signUser, data);
};
export const resumeSign = data => {
  return axios.post(config.resumeSign, data);
};
export const queryHrNameList = data => {
  return axios.post(config.queryHrNameList, data);
};
export const postAndDownResume = data => {
  return axios.post(config.postAndDownResume, data);
};
export const exportResume = data => {
  return axios.post(config.exportResume, data, { responseType: "blob" });
};
export const companyHrTeamexport = data => {
  return axios.post(config.companyHrTeamexport, data, { responseType: "blob" });
};
export const resourcelogExport = data => {
  return axios.post(config.resourcelogExport, data, { responseType: "blob" });
};
export const downResume = data => {
  return axios.post(config.downResume, data);
};
export const getcalendar = data => {
  return axios.post(config.getcalendar, data);
};
export const companyRole = data => {
  return axios.post(config.companyRole, data);
};
export const removeHr = data => {
  return axios.post(config.removeHr, data);
};
export const updatePayReminder = data => {
  return axios.post(config.updatePayReminder, data);
};
export const feedback = data => {
  return axios.post(config.feedback, data);
};
export const hrUpdate = data => {
  return axios.post(config.hrUpdate, data);
};
export const notificationSwitch = params => {
  return axios.get(config.notificationSwitch, params);
};
export const viCompany = params => {
  return axios.get(config.viCompany, params);
};
export const viIntro = params => {
  return axios.get(config.viIntro, params);
};
export const viIndex = params => {
  return axios.get(config.viIndex, params);
};
export const lookJobList = params => {
  return axios.get(config.lookJobList, params);
};
export const vipLog = params => {
  return axios.get(config.vipLog, params);
};
export const readOk = data => {
  return axios.get(config.readOk, data);
};
export const positionSearch = data => {
  return axios.post(config.positionSearch, data);
};
export const jobAdd = data => {
  return axios.post(config.jobAdd, data);
};
export const updateUser = data => {
  return axios.post(config.updateUser, data);
};
export const jobdelete = data => {
  return axios.get(config.jobdelete, data);
};
export const destroyUser = data => {
  return axios.get(config.destroyUser, data);
};
export const messageList = data => {
  return axios.get(config.messageList, data);
};
export const qualificationdelete = data => {
  return axios.get(config.qualificationdelete, data);
};
export const getListForUser = data => {
  return axios.post(config.getListForUser, data);
};
export const markBlack = data => {
  return axios.get(config.markBlack, data);
};
export const markRecomment = data => {
  return axios.get(config.markRecomment, data);
};
export const messageDetails = data => {
  return axios.get(config.messageDetails, data);
};
export const downRes = data => {
  return axios.get(config.downRes, data);
};
export const markConsider = data => {
  return axios.get(config.markConsider, data);
};
export const messagePages = data => {
  return axios.get(config.messagePages, data);
};
export const markNomatch = data => {
  return axios.get(config.markNomatch, data);
};
export const markMeet = data => {
  return axios.get(config.markMeet, data);
};
export const projectdelete = data => {
  return axios.get(config.projectdelete, data);
};
export const professionaldelete = data => {
  return axios.get(config.professionaldelete, data);
};
export const educationdelete = data => {
  return axios.get(config.educationdelete, data);
};
export const jobEdit = data => {
  return axios.post(config.jobEdit, data);
};
export const educationAdd = data => {
  return axios.post(config.educationAdd, data);
};
export const educationEdit = data => {
  return axios.post(config.educationEdit, data);
};
export const vipRights = data => {
  return axios.post(config.vipRights, data);
};
export const uploadFile = data => {
  return axios.post(config.uploadFile, data);
};
export const projectAdd = data => {
  return axios.post(config.projectAdd, data);
};
export const projectEdit = data => {
  return axios.post(config.projectEdit, data);
};
export const workbench = data => {
  return axios.post(config.workbench, data);
};
export const isMainCompanUser = data => {
  return axios.post(config.isMainCompanUser, data);
};
export const getUserList = data => {
  return axios.post(config.getUserList, data);
};

export const professionalEdit = data => {
  return axios.post(config.professionalEdit, data);
};
export const professionalAdd = data => {
  return axios.post(config.professionalAdd, data);
};
export const qualificationAdd = data => {
  return axios.post(config.qualificationAdd, data);
};
export const qualificationEdit = data => {
  return axios.post(config.qualificationEdit, data);
};
export const updateGR = data => {
  return axios.post(config.updateGR, data);
};
export const changeMobile = data => {
  return axios.post(config.changeMobile, data);
};
export const businessDetail = data => {
  return axios.post(config.businessDetail, data);
};
export const resumeUpload = data => {
  return axios.post(config.resumeUpload, data);
};
export const newFileUpload = data => {
  return axios.post(config.newUploadFile, data);
};
export const updateOne = data => {
  return axios.post(config.updateOne, data);
};
export const sendcode = data => {
  return axios.post(config.sendcode, data);
};
export const sendSmsToNewMobile = data => {
  return axios.post(config.sendSmsToNewMobile, data);
};
export const logout = data => {
  return axios.post(config.logout, data);
};
export const companyAdd = data => {
  return axios.post(config.companyAdd, data);
};
export const uploadHrAvatar = data => {
  return axios.post(config.uploadHrAvatar, data);
};
export const resourcePage = data => {
  return axios.post(config.resourcePage, data);
};
export const login = data => {
  return axios.post(config.login, data);
};
export const companyPay = data => {
  return axios.post(config.companyPay, data);
};
export const uploadLicensePicture = data => {
  return axios.post(config.uploadLicensePicture, data);
};
export const handleResource = data => {
  return axios.post(config.handleResource, data);
};
export const queryPayStatus = data => {
  return axios.post(config.queryPayStatus, data);
};
export const buyVipcompanyId = data => {
  return axios.post(config.buyVipcompanyId, data);
};
export const modifyMsg = data => {
  return axios.post(config.modifyMsg, data);
};
export const videoAdd = params => {
  return axios.get(config.videoAdd, { params: params });
};
export const videoUpdate = params => {
  return axios.get(config.videoUpdate, { params: params });
};

export const getVideos = params => {
  return axios.get(config.getVideos, { params: params });
};
export const inviteCode = params => {
  return axios.get(config.inviteCode, { params: params });
};
export const inviteRecord = data => {
  return axios.post(config.inviteRecord, data);
};
export const inviteRecordEr = data => {
  return axios.post(config.inviteRecordEr, data);
};

export const invitation = data => {
  return axios.post(config.invitation, data);
};
export const answerInvitation = data => {
  return axios.post(config.answerInvitation, data);
};
export const attendInitial = data => {
  return axios.post(config.attendInitial, data);
};
export const invitationAudit = data => {
  return axios.post(config.invitationAudit, data);
};
export const inputLog = data => {
  return axios.post(config.inputLog, data);
};
export const invitationStatus = params => {
  return axios.get(config.invitationStatus, { params: params });
};

/*
 * 创建Post x-www-form-urlencode请求参数
 * */
// function createPostParams(obj) {
//   return qs.stringify(obj)
// }

/**
 * 获取企业用户信息
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getHrHomeInfo = params => {
  return axios.get(config.getHrHomeInfo, { params: params });
};
// 常用语列表
export const phrasesPage = params => {
  return axios.get(config.phrasesPage, { params: params });
};

/**
 * 职位列表
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const jobList = params => {
  return axios.get(config.jobNameList, { params: params });
};

/**
 * 证书要求 列表
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const industryTreeCertificate = params => {
  return axios.get(config.industryTreeCertificate, { params: params });
};

/**
 * 添加企业职位
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const companyAddJob = data => {
  return axios.post(config.companyAddJob, data);
};

/**
 * 修改企业职位
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const companyEditJob = data => {
  return axios.post(config.companyEditJob, data);
};

/**
 *
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const companyJobUp = data => {
  return axios.put(config.companyJobUp, data);
};

/**
 *
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const companyJobDown = data => {
  return axios.put(config.companyJobDown, data);
};

/**
 *
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const companyJobDelete = data => {
  return axios.get(config.companyJobDelete, { params: data });
};

/**
 *
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const companyJobTop = data => {
  return axios.put(config.companyJobTop, data);
};

/**
 * 查询服务价格
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const companyQueryService = data => {
  return axios.get(config.companyQueryService, { params: data });
};

/**
 *
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const companyJobInfo = params => {
  return axios.get(config.companyJobInfo, { params: params });
};

/**
 *
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const companyJobRenewal = data => {
  return axios.put(config.companyJobRenewal, data);
};



// WEBPACK FOOTER //
// ./src/api/index.js